import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How to debug unified, rehype, or remark and fix bugs in markdown processing",
  "description": "",
  "published": "2020-08-17T00:00:00.000Z",
  "redirect_from": ["/blog/how-to-debug-unified-rehype-or-remark-and-fix-bugs-in-markdown-processing/swizec/9479"],
  "categories": "Computer Science, Technical"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ever had to debug a compiler my friend? It's hard.`}</p>
    <p>{`Typical engineering wisdom goes that if you blame the compiler, you're wrong. You messed up and can't figure it out and it is `}<em parentName="p">{`not the compiler's fault`}</em>{`.`}</p>
    <p>{`But sometimes it is.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=6oO3IfxOOoA"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M190%20107v11c1%201%2012%202%2016%201l4-1v-12l-10-1c-8%200-10%200-10%202m61%2044l-73%201h-75v2l-1%206c0%204-1%205-7%205-3%200-3%200%202%201l-25%201H42v-5H0v63h401v-32c0-30%200-30-1-6v27h-90l-1-3-1-31v-28h-25c-16%200-24%200-23-1l-6-1c-4%200-5%200-3%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/05675bfc853030683fad05d167ec1e09/ca0a1/techletter.app-screenshot-1597679792741.webp 223w", "/static/05675bfc853030683fad05d167ec1e09/75680/techletter.app-screenshot-1597679792741.webp 445w", "/static/05675bfc853030683fad05d167ec1e09/8d1ba/techletter.app-screenshot-1597679792741.webp 890w", "/static/05675bfc853030683fad05d167ec1e09/3838e/techletter.app-screenshot-1597679792741.webp 1335w", "/static/05675bfc853030683fad05d167ec1e09/e11e5/techletter.app-screenshot-1597679792741.webp 1780w", "/static/05675bfc853030683fad05d167ec1e09/a454f/techletter.app-screenshot-1597679792741.webp 2556w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/05675bfc853030683fad05d167ec1e09/e92b6/techletter.app-screenshot-1597679792741.png 223w", "/static/05675bfc853030683fad05d167ec1e09/e66bf/techletter.app-screenshot-1597679792741.png 445w", "/static/05675bfc853030683fad05d167ec1e09/4ef49/techletter.app-screenshot-1597679792741.png 890w", "/static/05675bfc853030683fad05d167ec1e09/4e814/techletter.app-screenshot-1597679792741.png 1335w", "/static/05675bfc853030683fad05d167ec1e09/701e9/techletter.app-screenshot-1597679792741.png 1780w", "/static/05675bfc853030683fad05d167ec1e09/6b690/techletter.app-screenshot-1597679792741.png 2556w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/05675bfc853030683fad05d167ec1e09/4ef49/techletter.app-screenshot-1597679792741.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`I'm working on a script to `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/wordpress-to-markdown"
      }}>{`convert Wordpress exports to Markdown`}</a>{` and after months of tinkering, noticed a terrible bug. JSX code samples don't work.`}</p>
    <p>{`You take this bit of Wordpress source code:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=html&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%3Cpre%20lang%3D%22javascript%22%3E%0Aclass%20ReportSize%20extends%20React.Component%20%7B%0A%20%20refCallback%20%3D%20element%20%3D%3E%20%7B%0A%20%20%20%20if%20(element)%20%7B%0A%20%20%20%20%20%20this.props.getSize(element.getBoundingClientRect())%3B%0A%20%20%20%20%7D%0A%20%20%7D%3B%0A%0A%20%20render()%20%7B%0A%20%20%20%20return%20(%0A%20%20%20%20%20%20%3Cdiv%20ref%3D%7Bthis.refCallback%7D%20style%3D%7B%7B%20border%3A%20%221px%20solid%20red%22%20%7D%7D%3E%0A%20%20%20%20%20%20%20%20%7Bfaker.lorem.paragraphs(Math.random()%20*%2010)%7D%0A%20%20%20%20%20%20%3C%2Fdiv%3E%0A%20%20%20%20)%3B%0A%20%20%7D%0A%7D%0A%3C%2Fpre%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "71.74887892376681%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'286\\'%20viewBox=\\'0%200%20400%20286\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M20%2030c-1%202-2%20225%200%20227%201%201%2022%202%20180%202s179-1%20180-2c2-2%201-225%200-227-2-2-358-2-360%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fc276a22fbc40ff5304f7938648c6980/ca0a1/techletter.app-screenshot-1597679790529.webp 223w", "/static/fc276a22fbc40ff5304f7938648c6980/75680/techletter.app-screenshot-1597679790529.webp 445w", "/static/fc276a22fbc40ff5304f7938648c6980/8d1ba/techletter.app-screenshot-1597679790529.webp 890w", "/static/fc276a22fbc40ff5304f7938648c6980/c2b18/techletter.app-screenshot-1597679790529.webp 1324w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fc276a22fbc40ff5304f7938648c6980/e92b6/techletter.app-screenshot-1597679790529.png 223w", "/static/fc276a22fbc40ff5304f7938648c6980/e66bf/techletter.app-screenshot-1597679790529.png 445w", "/static/fc276a22fbc40ff5304f7938648c6980/4ef49/techletter.app-screenshot-1597679790529.png 890w", "/static/fc276a22fbc40ff5304f7938648c6980/eb2ef/techletter.app-screenshot-1597679790529.png 1324w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/fc276a22fbc40ff5304f7938648c6980/4ef49/techletter.app-screenshot-1597679790529.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`And you get this output:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=null&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%60%60javascript%0Aclass%20ReportSize%20extends%20React.Component%20%7B%0A%20%20refCallback%20%3D%20element%20%3D%3E%20%7B%0A%20%20%20%20if%20(element)%20%7B%0A%20%20%20%20%20%20this.props.getSize(element.getBoundingClientRect())%3B%0A%20%20%20%20%7D%0A%20%20%7D%3B%0A%0A%20%20render()%20%7B%0A%20%20%20%20return%20(%0A%20%20%20%20%0A%20%20%20%20%20%20%20%20%7Bfaker.lorem.paragraphs(Math.random()%20*%2010)%7D%0A%0A%20%20%20%20)%3B%0A%20%20%7D%0A%7D%0A%60%60"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "83.85650224215246%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'335\\'%20viewBox=\\'0%200%20400%20335\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2035a6757%206757%200%20001%20267c3%202%20348%201%20350%200s2-10%202-134V35l-177-1-176%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2d5285b5a3ffbcf6898b68c8e303ea23/ca0a1/techletter.app-screenshot-1597679790389.webp 223w", "/static/2d5285b5a3ffbcf6898b68c8e303ea23/75680/techletter.app-screenshot-1597679790389.webp 445w", "/static/2d5285b5a3ffbcf6898b68c8e303ea23/8d1ba/techletter.app-screenshot-1597679790389.webp 890w", "/static/2d5285b5a3ffbcf6898b68c8e303ea23/cc785/techletter.app-screenshot-1597679790389.webp 1132w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2d5285b5a3ffbcf6898b68c8e303ea23/e92b6/techletter.app-screenshot-1597679790389.png 223w", "/static/2d5285b5a3ffbcf6898b68c8e303ea23/e66bf/techletter.app-screenshot-1597679790389.png 445w", "/static/2d5285b5a3ffbcf6898b68c8e303ea23/4ef49/techletter.app-screenshot-1597679790389.png 890w", "/static/2d5285b5a3ffbcf6898b68c8e303ea23/ae953/techletter.app-screenshot-1597679790389.png 1132w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/2d5285b5a3ffbcf6898b68c8e303ea23/4ef49/techletter.app-screenshot-1597679790389.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`But you're supposed to get this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=null&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%60%60javascript%0Aclass%20ReportSize%20extends%20React.Component%20%7B%0A%20%20refCallback%20%3D%20element%20%3D%3E%20%7B%0A%20%20%20%20if%20(element)%20%7B%0A%20%20%20%20%20%20this.props.getSize(element.getBoundingClientRect())%3B%0A%20%20%20%20%7D%0A%20%20%7D%3B%0A%0A%20%20render()%20%7B%0A%20%20%20%20return%20(%0A%20%20%20%20%20%20%3Cdiv%20ref%3D%7Bthis.refCallback%7D%20style%3D%7B%7B%20border%3A%20%221px%20solid%20%20red%22%20%7D%7D%3E%0A%20%20%20%20%20%20%20%20%7Bfaker.lorem.paragraphs(Math.random()%20*%2010)%7D%0A%20%20%20%20%20%20%3C%2Fdiv%3E%0A%20%20%20%20)%3B%0A%20%20%7D%0A%7D%0A%60%60"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "70.85201793721974%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'283\\'%20viewBox=\\'0%200%20400%20283\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M20%2030a4806%204806%200%20001%20225c3%202%20356%201%20358%200s2-9%202-113V30l-181-1-180%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/13f2e67491c66342f4bd0bf078f80eb5/ca0a1/techletter.app-screenshot-1597679790476.webp 223w", "/static/13f2e67491c66342f4bd0bf078f80eb5/75680/techletter.app-screenshot-1597679790476.webp 445w", "/static/13f2e67491c66342f4bd0bf078f80eb5/8d1ba/techletter.app-screenshot-1597679790476.webp 890w", "/static/13f2e67491c66342f4bd0bf078f80eb5/3838e/techletter.app-screenshot-1597679790476.webp 1335w", "/static/13f2e67491c66342f4bd0bf078f80eb5/89344/techletter.app-screenshot-1597679790476.webp 1340w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/13f2e67491c66342f4bd0bf078f80eb5/e92b6/techletter.app-screenshot-1597679790476.png 223w", "/static/13f2e67491c66342f4bd0bf078f80eb5/e66bf/techletter.app-screenshot-1597679790476.png 445w", "/static/13f2e67491c66342f4bd0bf078f80eb5/4ef49/techletter.app-screenshot-1597679790476.png 890w", "/static/13f2e67491c66342f4bd0bf078f80eb5/4e814/techletter.app-screenshot-1597679790476.png 1335w", "/static/13f2e67491c66342f4bd0bf078f80eb5/acf8f/techletter.app-screenshot-1597679790476.png 1340w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/13f2e67491c66342f4bd0bf078f80eb5/4ef49/techletter.app-screenshot-1597679790476.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The compiler that translates plain Wordpress HTML to Markdown makes a mistake. Sees HTML inside a code sample, parses it as HTML, then silently drops it.`}</p>
    <p>{`🙃`}</p>
    <p>{`How would you fix this?`}</p>
    <p>{`I verified the input is all correct until it goes into the html-to-markdown compiler. That's always a good first step. `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Garbage_in,_garbage_out"
      }}>{`Garbage in, garbage out`}</a></p>
    <h2 {...{
      "id": "how-compilers-work"
    }}>{`How compilers work`}</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/95bd48d30787b54a299f454d67b13ee6/5a190/EDCVI2Q.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "57.847533632286996%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'232\\'%20viewBox=\\'0%200%20400%20232\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M143%2047c-11%202-13%202-13%204a17326%2017326%200%2000-3%2018l6-18c3-2%2070-5%2072-3l-6%2018-2%207%204-8a254%20254%200%20017-18h-65m34%2027a1137%201137%200%2001-26%203l8-1v3c-3%2010-3%2010%200%2010l12-2%208-1h-16l-4%201%201-3c1-8%201-8%2013-9a231%20231%200%200119-2l-1-1-14%202m58%202a3524%203524%200%2001-52%204l-3%2011a2495%202495%200%20004-7l1-4h9a22102%2022102%200%200052-3h15v3c0%203%200%207-4%2022%200%203-31%205-65%203h-14c-3%201%207%202%2020%202s14%200%2014%202l-4%2015c1%202%2018%203%2020%201l2-1c2%200%202%200-1%203l-5%203-1%201c-2%202%203%201%207-3l4-3v10a198%20198%200%2001-1%2017l2-39-1%206c0%204%200%205-1%204l-10-2%202%202c2%201%201%201-4%201-12%202-13%200-9-10l1-6%2011-1%2023-1%2012-1v-5l3-11%201-10-1-4h-11l-16%201m35%2033h-21c-10%200-16%200-16%202l2%201a725%20725%200%200167-1v2c2%202-2%2037-5%2037l-6%201a412%20412%200%2001-59%202c-1%202%2056%200%2065-1%203-1%203-1%204-5l2-15c2-13%202-22%201-23h-34\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/95bd48d30787b54a299f454d67b13ee6/ca0a1/EDCVI2Q.webp 223w", "/static/95bd48d30787b54a299f454d67b13ee6/75680/EDCVI2Q.webp 445w", "/static/95bd48d30787b54a299f454d67b13ee6/d00b9/EDCVI2Q.webp 800w"],
              "sizes": "(max-width: 800px) 100vw, 800px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/95bd48d30787b54a299f454d67b13ee6/e92b6/EDCVI2Q.png 223w", "/static/95bd48d30787b54a299f454d67b13ee6/e66bf/EDCVI2Q.png 445w", "/static/95bd48d30787b54a299f454d67b13ee6/5a190/EDCVI2Q.png 800w"],
              "sizes": "(max-width: 800px) 100vw, 800px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/95bd48d30787b54a299f454d67b13ee6/5a190/EDCVI2Q.png",
              "alt": "EDCVI2Q",
              "title": "EDCVI2Q",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Compilers work in 3 stages.`}</p>
    <ol>
      <li parentName="ol">{`The front-end parses text inputs into an Abstract Syntax Tree – AST`}</li>
      <li parentName="ol">{`The middle-end manipulates the AST to add optimizations and other changes`}</li>
      <li parentName="ol">{`The back-end turns your AST back to text`}</li>
    </ol>
    <p>{`That's the general idea. You can read about compilers in more detail in my `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/lolcode-to-javascript-compiler-babel-macro/swizec/9083"
      }}>{`LOLCODE-to-JavaScript compiler`}</a>{` article.`}</p>
    <h3 {...{
      "id": "modern-tools-for-markdown-processing"
    }}>{`Modern tools for Markdown processing`}</h3>
    <p>{`Your best bet to play with markdown right now is the `}<a parentName="p" {...{
        "href": "https://unifiedjs.com/"
      }}>{`Unified`}</a>{` ecosystem. It's what Gatsby, Next, Prettier, and many others use.`}</p>
    <p>{`Unified is a system of plugins with plugins that let you parse, process, and output ASTs. Easy to get started and confusing to dig deep. Hard to find the code that `}<em parentName="p">{`does`}</em>{` anything.`}</p>
    <p>{`Every plugin calls another plugin. 😅`}</p>
    <p>{`General lay of the land is that:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/unifiedjs/unified"
        }}>{`unified`}</a>{` is the protocol that holds it all together`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/rehypejs/rehype"
        }}>{`rehype`}</a>{` is the plugin ecosystem for HTML parsing/rendering`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/remarkjs/remark"
        }}>{`remark`}</a>{` is the plugin ecosystem for Markdown parsing/rendering`}</li>
    </ul>
    <p>{`A basic example that parses HTML and spits out Markdown goes like this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=import%20parse%20from%20'rehype-parse'%0Aimport%20rehype2remark%20from%20'rehype-remark'%0Aimport%20stringify%20from%20'remark-stringify'%0A%0Aunified()%20%2F%2F%20initiate%20the%20pipeline%0A%09.use(parse)%20%2F%2F%20parse%20HTML%20to%20AST%0A%09.use(rehype2remark)%20%2F%2F%20translate%20Rehype%20AST%20to%20Remark%20AST%0A%09.use(stringify)%20%2F%2F%20stringify%20AST%20to%20markdown%0A%09.process(inputHTML%2C%20(err%2C%20markdown)%20%3D%3E%20%7B%0A%09%09console.log(markdown)%0A%09%7D)"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "61.88340807174888%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'248\\'%20viewBox=\\'0%200%20400%20248\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M26%2033l-3%201-1%2090%201%2092h354l1-92V34l-3-1a12316%2012316%200%2000-349%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ead57719d77f281c1a99d630c0b84b85/ca0a1/techletter.app-screenshot-1597679790671.webp 223w", "/static/ead57719d77f281c1a99d630c0b84b85/75680/techletter.app-screenshot-1597679790671.webp 445w", "/static/ead57719d77f281c1a99d630c0b84b85/8d1ba/techletter.app-screenshot-1597679790671.webp 890w", "/static/ead57719d77f281c1a99d630c0b84b85/2baf0/techletter.app-screenshot-1597679790671.webp 1180w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ead57719d77f281c1a99d630c0b84b85/e92b6/techletter.app-screenshot-1597679790671.png 223w", "/static/ead57719d77f281c1a99d630c0b84b85/e66bf/techletter.app-screenshot-1597679790671.png 445w", "/static/ead57719d77f281c1a99d630c0b84b85/4ef49/techletter.app-screenshot-1597679790671.png 890w", "/static/ead57719d77f281c1a99d630c0b84b85/c83ae/techletter.app-screenshot-1597679790671.png 1180w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ead57719d77f281c1a99d630c0b84b85/4ef49/techletter.app-screenshot-1597679790671.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <h2 {...{
      "id": "how-you-debug-a-compiler"
    }}>{`How you debug a compiler`}</h2>
    <p>{`Debugging a compiler is where life gets tricky. A whole processing pipeline, oof.`}</p>
    <p>{`You're trying to find out which step of the processing pipeline makes a mistake. And whether it's a mistake at all. You `}<em parentName="p">{`could`}</em>{` still be the one holding it wrong.`}</p>
    <p>{`Works for everyone else. Chances are you're holding it wrong. But how do you figure out `}<em parentName="p">{`how`}</em>{` you're holding it wrong?`}</p>
    <p>{`You can watch me work through the issue here:`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=6oO3IfxOOoA"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M190%20107v11c1%201%2012%202%2016%201l4-1v-12l-10-1c-8%200-10%200-10%202m61%2044l-73%201h-75v2l-1%206c0%204-1%205-7%205-3%200-3%200%202%201l-25%201H42v-5H0v63h401v-32c0-30%200-30-1-6v27h-90l-1-3-1-31v-28h-25c-16%200-24%200-23-1l-6-1c-4%200-5%200-3%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/352360239a11087377ff7a17111f2861/ca0a1/techletter.app-screenshot-1597679797967.webp 223w", "/static/352360239a11087377ff7a17111f2861/75680/techletter.app-screenshot-1597679797967.webp 445w", "/static/352360239a11087377ff7a17111f2861/8d1ba/techletter.app-screenshot-1597679797967.webp 890w", "/static/352360239a11087377ff7a17111f2861/3838e/techletter.app-screenshot-1597679797967.webp 1335w", "/static/352360239a11087377ff7a17111f2861/e11e5/techletter.app-screenshot-1597679797967.webp 1780w", "/static/352360239a11087377ff7a17111f2861/a454f/techletter.app-screenshot-1597679797967.webp 2556w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/352360239a11087377ff7a17111f2861/e92b6/techletter.app-screenshot-1597679797967.png 223w", "/static/352360239a11087377ff7a17111f2861/e66bf/techletter.app-screenshot-1597679797967.png 445w", "/static/352360239a11087377ff7a17111f2861/4ef49/techletter.app-screenshot-1597679797967.png 890w", "/static/352360239a11087377ff7a17111f2861/4e814/techletter.app-screenshot-1597679797967.png 1335w", "/static/352360239a11087377ff7a17111f2861/701e9/techletter.app-screenshot-1597679797967.png 1780w", "/static/352360239a11087377ff7a17111f2861/6b690/techletter.app-screenshot-1597679797967.png 2556w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/352360239a11087377ff7a17111f2861/4ef49/techletter.app-screenshot-1597679797967.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`I go through the process methodically injecting console.logs into the pipeline to see how nodes change shape. Trying to figure out where it goes wrong.`}</p>
    <p>{`In the end I decided it wasn't a bug. Or if it was, it's too deep for me to fix.`}</p>
    <h3 {...{
      "id": "a-debugging-kludge"
    }}>{`A debugging kludge`}</h3>
    <p>{`First you create a small example. As small as possible.`}</p>
    <p>{`Then you build a debugging kludge – a tiny plugin that helps you hook into the compilation process.`}</p>
    <p>{`It's a kludge because it's temporary, dirty, and for your eyes only. Like slapping a `}<inlineCode parentName="p">{`console.log`}</inlineCode>{` into your code to see what's going on.`}</p>
    <p>{`Your pipeline has two sides, if you're translating HTML to Markdown:`}</p>
    <ol>
      <li parentName="ol">{`The Rehype side`}</li>
      <li parentName="ol">{`The Remark side`}</li>
    </ol>
    <p>{`These require different kludges because the AST structure is different. Tag naming is different, properties are different, etc. Both are tree structures.`}</p>
    <h4 {...{
      "id": "debug-a-rehype-ast"
    }}>{`Debug a Rehype AST`}</h4>
    <p>{`To see how Rehype sees your code blocks, you use a kludge like this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20debugCodeBlocks()%20%7B%0A%20%20%20%20function%20findCodeBlocks(node)%20%7B%0A%20%20%20%20%20%20%20%20let%20nodes%20%3D%20%5B%5D%3B%0A%0A%20%20%20%20%20%20%20%20if%20(node.tagName%20%3D%3D%3D%20%22pre%22)%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20nodes.push(node)%3B%20%2F%2F%20%3Cpre%3E%20nodes%20are%20code%20blocks%0A%20%20%20%20%20%20%20%20%7D%20else%20if%20(node.children)%20%7B%0A%09%09%20%20%20%20%20%20%20%20%2F%2F%20recursively%20walk%20through%20child%20nodes%0A%20%20%20%20%20%20%20%20%20%20%20%20for%20(let%20child%20of%20node.children)%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20nodes.push(...findCodeBlocks(child))%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%7D%0A%0A%20%20%20%20%20%20%20%20return%20nodes%3B%0A%20%20%20%20%7D%0A%20%20%20%20%0A%20%20%20%20return%20tree%20%3D%3E%20%7B%0A%09%20%20%20%20const%20codeBlocks%20%3D%20findCodeBlocks(tree)%0A%09%20%20%20%20%0A%09%20%20%20%20%2F%2F%20deep%20print%20the%20codeBlocks%20array%0A%09%20%20%20%20console.log(require(%22util%22).inspect(tree%2C%20false%2C%20null%2C%20true))%3B%0A%09%20%20%20%20%0A%09%20%20%20%20return%20tree%3B%0A%20%20%20%20%7D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "93.27354260089686%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'373\\'%20viewBox=\\'0%200%20400%20373\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M20%2030c-1%202-2%20312%200%20314%201%202%20359%202%20360%200%202-2%201-312%200-314-2-2-358-2-360%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6e613936245e8c6fa74b1f1475a98645/ca0a1/techletter.app-screenshot-1597679790968.webp 223w", "/static/6e613936245e8c6fa74b1f1475a98645/75680/techletter.app-screenshot-1597679790968.webp 445w", "/static/6e613936245e8c6fa74b1f1475a98645/8d1ba/techletter.app-screenshot-1597679790968.webp 890w", "/static/6e613936245e8c6fa74b1f1475a98645/c2b18/techletter.app-screenshot-1597679790968.webp 1324w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6e613936245e8c6fa74b1f1475a98645/e92b6/techletter.app-screenshot-1597679790968.png 223w", "/static/6e613936245e8c6fa74b1f1475a98645/e66bf/techletter.app-screenshot-1597679790968.png 445w", "/static/6e613936245e8c6fa74b1f1475a98645/4ef49/techletter.app-screenshot-1597679790968.png 890w", "/static/6e613936245e8c6fa74b1f1475a98645/eb2ef/techletter.app-screenshot-1597679790968.png 1324w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/6e613936245e8c6fa74b1f1475a98645/4ef49/techletter.app-screenshot-1597679790968.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Look at the output and you see what Rehype sees. Every property, node structure, and value.`}</p>
    <p>{`Change the `}<inlineCode parentName="p">{`if`}</inlineCode>{` to observe different nodes. I don't recommend printing the whole AST. Too much.`}</p>
    <h4 {...{
      "id": "debug-a-remark-ast"
    }}>{`Debug a Remark AST`}</h4>
    <p>{`On the other side of the `}<inlineCode parentName="p">{`rehype2remark`}</inlineCode>{` divide, you have a Markdown AST. Same basic structure, different naming conventions.`}</p>
    <p>{`Remark is easier to debug because it's well-supported by the `}<a parentName="p" {...{
        "href": "https://github.com/syntax-tree/unist"
      }}>{`unist`}</a>{` ecosystem of helper plugins. 🎉`}</p>
    <p>{`To print code blocks on the Remark side:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=import%20visit%20from%20%22unist-util-visit%22%3B%0A%0Afunction%20codeBlockDebugger()%20%7B%0A%20%20%20%20return%20(markdownAST)%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20visit(markdownAST%2C%20%22code%22%2C%20(node)%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20console.log(require(%22util%22).inspect(node%2C%20false%2C%20null%2C%20true))%3B%0A%20%20%20%20%20%20%20%20%7D)%3B%0A%20%20%20%20%7D%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "47.53363228699552%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'190\\'%20viewBox=\\'0%200%20400%20190\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M19%2030a1908%201908%200%20001%20132c2%203%20358%203%20360%200%202-1%202-8%202-66l-1-66c-1-3-361-3-362%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4e0ad3b147bd5d85cac93542a7220480/ca0a1/techletter.app-screenshot-1597679790566.webp 223w", "/static/4e0ad3b147bd5d85cac93542a7220480/75680/techletter.app-screenshot-1597679790566.webp 445w", "/static/4e0ad3b147bd5d85cac93542a7220480/8d1ba/techletter.app-screenshot-1597679790566.webp 890w", "/static/4e0ad3b147bd5d85cac93542a7220480/3838e/techletter.app-screenshot-1597679790566.webp 1335w", "/static/4e0ad3b147bd5d85cac93542a7220480/5c6e0/techletter.app-screenshot-1597679790566.webp 1388w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4e0ad3b147bd5d85cac93542a7220480/e92b6/techletter.app-screenshot-1597679790566.png 223w", "/static/4e0ad3b147bd5d85cac93542a7220480/e66bf/techletter.app-screenshot-1597679790566.png 445w", "/static/4e0ad3b147bd5d85cac93542a7220480/4ef49/techletter.app-screenshot-1597679790566.png 890w", "/static/4e0ad3b147bd5d85cac93542a7220480/4e814/techletter.app-screenshot-1597679790566.png 1335w", "/static/4e0ad3b147bd5d85cac93542a7220480/c1bea/techletter.app-screenshot-1597679790566.png 1388w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/4e0ad3b147bd5d85cac93542a7220480/4ef49/techletter.app-screenshot-1597679790566.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The `}<inlineCode parentName="p">{`visit`}</inlineCode>{` helper handles recursion for you.`}</p>
    <h2 {...{
      "id": "how-to-fix-a-compiler-pipeline-issue"
    }}>{`How to fix a compiler pipeline issue`}</h2>
    <p>{`There's 3 ways to fix a compiler pipeline issue:`}</p>
    <ol>
      <li parentName="ol">{`On the parsing side`}</li>
      <li parentName="ol">{`In the middle`}</li>
      <li parentName="ol">{`On the stringify side`}</li>
    </ol>
    <p>{`Fixing parsers by hand is hard. Writing, too. Most parsers are auto-generated from `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/GNU_Bison"
      }}>{`grammar definition files`}</a>{`.`}</p>
    <p>{`Rehype parses my JSX-containing code blocks as if they were HTML. I thought they should be strings.`}</p>
    <p>{`After digging, I discovered that Rehype uses `}<a parentName="p" {...{
        "href": "https://github.com/inikulin/parse5"
      }}>{`Parse5`}</a>{` – an HTML5 compliant parser used in the entire Node ecosystem. With 75,000,000 downloads per month ... yeah I'm the one who's wrong.`}</p>
    <p><img parentName="p" {...{
        "src": "/58640ba715f7691da8c337c98f256068/media-tI5T4zw7zVze8-giphy.gif",
        "alt": "im_wrong giphy"
      }}></img></p>
    <p>{`Fixing stringification is boring. You'll dig and dig and do nothing fun for days. Shit's boring, we did it for my compilers class in college.`}</p>
    <p>{`Plus you've got a battle-tested stringifier right there. You need to give it the right input tree 😉`}</p>
    <h2 {...{
      "id": "macgyver-a-fix-in-the-middle"
    }}>{`MacGyver a fix in the middle`}</h2>
    <p><img parentName="p" {...{
        "src": "/7300e660e504a4579869f35660a929f3/media-16KdaesKdaAI8-giphy.gif",
        "alt": "macgyver giphy"
      }}></img></p>
    <p>{`Compiler middleware is the best place to add your fix.`}</p>
    <p>{`Take the AST, change it so stringification does what you want. Magic.`}</p>
    <p>{`Here's what I did for my example of JSX-containing code blocks:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20fixCodeBlocks()%20%7B%0A%20%20%20%20const%20settings%20%3D%20%7B%0A%20%20%20%20%20%20%20%20quoteSmart%3A%20false%2C%0A%20%20%20%20%20%20%20%20closeSelfClosing%3A%20false%2C%0A%20%20%20%20%20%20%20%20omitOptionalTags%3A%20false%2C%0A%20%20%20%20%20%20%20%20entities%3A%20%7B%20useShortestReferences%3A%20true%20%7D%2C%0A%20%20%20%20%7D%3B%0A%0A%20%20%20%20return%20(tree)%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20%2F%2F%20same%20recursion%20findCodeBlocks%20as%20above%0A%20%20%20%20%20%20%20%20const%20codeBlocks%20%3D%20findCodeBlocks(tree)%3B%0A%0A%20%20%20%20%20%20%20%20for%20(let%20block%20of%20codeBlocks)%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%2F%2F%20copy%20position%20info%20for%20the%20whole%20%3Cpre%3E%20so%20we%20can%20fake%20it%20later%0A%20%20%20%20%20%20%20%20%20%20%20%20const%20position%20%3D%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20start%3A%20block.children%5B0%5D.position.start%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20end%3A%20block.children%5Bblock.children.length%20-%201%5D.position.end%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D%3B%0A%0A%20%20%20%20%20%20%20%20%20%20%20%20%2F%2F%20replace%20children%20with%20my%20fakes%0A%20%20%20%20%20%20%20%20%20%20%20%20block.children%20%3D%20%5B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%0A%20%20%20%20%20%20%20%20%20%20%20%20%5D%3B%0A%20%20%20%20%20%20%20%20%7D%0A%0A%20%20%20%20%20%20%20%20return%20tree%3B%0A%20%20%20%20%7D%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "93.72197309417041%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'374\\'%20viewBox=\\'0%200%20400%20374\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M19%2028a9744%209744%200%20001%20320h361l1-161V28l-182-1-181%201M8%20363H0v11h401v-12H209L8%20363\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6b16d43db9bdd996c3b7cb61f1dd7f56/ca0a1/techletter.app-screenshot-1597679790704.webp 223w", "/static/6b16d43db9bdd996c3b7cb61f1dd7f56/75680/techletter.app-screenshot-1597679790704.webp 445w", "/static/6b16d43db9bdd996c3b7cb61f1dd7f56/8d1ba/techletter.app-screenshot-1597679790704.webp 890w", "/static/6b16d43db9bdd996c3b7cb61f1dd7f56/3838e/techletter.app-screenshot-1597679790704.webp 1335w", "/static/6b16d43db9bdd996c3b7cb61f1dd7f56/a5a81/techletter.app-screenshot-1597679790704.webp 1436w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6b16d43db9bdd996c3b7cb61f1dd7f56/e92b6/techletter.app-screenshot-1597679790704.png 223w", "/static/6b16d43db9bdd996c3b7cb61f1dd7f56/e66bf/techletter.app-screenshot-1597679790704.png 445w", "/static/6b16d43db9bdd996c3b7cb61f1dd7f56/4ef49/techletter.app-screenshot-1597679790704.png 890w", "/static/6b16d43db9bdd996c3b7cb61f1dd7f56/4e814/techletter.app-screenshot-1597679790704.png 1335w", "/static/6b16d43db9bdd996c3b7cb61f1dd7f56/85e74/techletter.app-screenshot-1597679790704.png 1436w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/6b16d43db9bdd996c3b7cb61f1dd7f56/4ef49/techletter.app-screenshot-1597679790704.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Find all the code blocks, replace their children with a fake new child.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20add%20a%20fake%20%3Ccode%3E%20block%0A%2F%2F%20helps%20preserve%20language%20property%0A%7B%0A%20%20%20%20type%3A%20%22element%22%2C%0A%20%20%20%20tagName%3A%20%22code%22%2C%0A%20%20%20%20properties%3A%20%7B%0A%20%20%20%20%20%20%20%20className%3A%20%5B%0A%20%20%20%20%20%20%20%20%20%20%20%20%60language-%24%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20block.properties%20%26%26%20block.properties.lang%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D%60%2C%0A%20%20%20%20%20%20%20%20%5D%2C%0A%20%20%20%20%7D%2C%0A%20%20%20%20children%3A%20%5B%0A%20%20%20%20%20%20%20%20%2F%2F%20stringify%20the%20full%20%3Cpre%3E%20block%0A%20%20%20%20%20%20%20%20%2F%2F%20as%20a%20text%20child%20of%20the%20new%20%3Ccode%3E%20block%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%0A%20%20%20%20%20%20%20%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20type%3A%20%22text%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%2F%2F%20hast-util-to-html%2C%20Rehype's%20stringifier%0A%20%20%20%20%20%20%20%20%20%20%20%20value%3A%20toHTML(block%2C%20settings)%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20.replace(%22%3C%2Fpre%3E%22%2C%20%22%22)%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20.replace(%2F%5C%3Cpre.*%3E%2F%2C%20%22%22)%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%2F%2F%20this%20fixes%20a%20bug%20caused%20by%20a%20dirty%20fix%20somewhere%20else%20%3AP%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20.replace(%2F%5C%3Cp%5C%3E%5C%3C%5C%2Fp%5C%3E%2Fg%2C%20%22%5Cn%5Cn%22)%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20position%2C%0A%20%20%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%5D%2C%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "93.27354260089686%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'373\\'%20viewBox=\\'0%200%20400%20373\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M19%2029c-2%201-1%20315%200%20317%202%202%20360%202%20362%200l1-160V29l-182-1-181%201M0%20372\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3f0c1f1a03dd323775611a5985b4bb2f/ca0a1/techletter.app-screenshot-1597679790714.webp 223w", "/static/3f0c1f1a03dd323775611a5985b4bb2f/75680/techletter.app-screenshot-1597679790714.webp 445w", "/static/3f0c1f1a03dd323775611a5985b4bb2f/8d1ba/techletter.app-screenshot-1597679790714.webp 890w", "/static/3f0c1f1a03dd323775611a5985b4bb2f/3838e/techletter.app-screenshot-1597679790714.webp 1335w", "/static/3f0c1f1a03dd323775611a5985b4bb2f/f028a/techletter.app-screenshot-1597679790714.webp 1404w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3f0c1f1a03dd323775611a5985b4bb2f/e92b6/techletter.app-screenshot-1597679790714.png 223w", "/static/3f0c1f1a03dd323775611a5985b4bb2f/e66bf/techletter.app-screenshot-1597679790714.png 445w", "/static/3f0c1f1a03dd323775611a5985b4bb2f/4ef49/techletter.app-screenshot-1597679790714.png 890w", "/static/3f0c1f1a03dd323775611a5985b4bb2f/4e814/techletter.app-screenshot-1597679790714.png 1335w", "/static/3f0c1f1a03dd323775611a5985b4bb2f/f793b/techletter.app-screenshot-1597679790714.png 1404w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/3f0c1f1a03dd323775611a5985b4bb2f/4ef49/techletter.app-screenshot-1597679790714.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Make the child a `}<inlineCode parentName="p">{`<code>`}</inlineCode>{` block because Remark likes that better and stringify the whole `}<inlineCode parentName="p">{`<pre>`}</inlineCode>{` tag into a single `}<inlineCode parentName="p">{`text`}</inlineCode>{` node.`}</p>
    <p>{`You get:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=null&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%60%60javascript%0Aclass%20ReportSize%20extends%20React.Component%20%7B%0A%20%20refCallback%20%3D%20element%20%3D%3E%20%7B%0A%20%20%20%20if%20(element)%20%7B%0A%20%20%20%20%20%20this.props.getSize(element.getBoundingClientRect())%3B%0A%20%20%20%20%7D%0A%20%20%7D%3B%0A%0A%20%20render()%20%7B%0A%20%20%20%20return%20(%0A%20%20%20%20%20%20%3Cdiv%20ref%3D%22%7Bthis.refCallback%7D%22%20style%3D%22%7B%7B%22%20border%3A%3D%22%22%20%26%2334%3B1px%3D%22%22%20solid%3D%22%22%20red%26%2334%3B%3D%22%22%20%7D%7D%3D%22%22%3E%0A%20%20%20%20%20%20%20%20%7Bfaker.lorem.paragraphs(Math.random()%20*%2010)%7D%0A%20%20%20%20%20%20%3C%2Fdiv%3E%0A%20%20%20%20)%3B%0A%20%20%7D%0A%7D%0A%60%60"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "53.81165919282511%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'216\\'%20viewBox=\\'0%200%20400%20216\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M15%2057v137c1%202%20369%202%20370%200V22H15v35\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/19509b4e3471d1b8f741c688c0e4ccb9/ca0a1/techletter.app-screenshot-1597679790629.webp 223w", "/static/19509b4e3471d1b8f741c688c0e4ccb9/75680/techletter.app-screenshot-1597679790629.webp 445w", "/static/19509b4e3471d1b8f741c688c0e4ccb9/8d1ba/techletter.app-screenshot-1597679790629.webp 890w", "/static/19509b4e3471d1b8f741c688c0e4ccb9/3838e/techletter.app-screenshot-1597679790629.webp 1335w", "/static/19509b4e3471d1b8f741c688c0e4ccb9/3afba/techletter.app-screenshot-1597679790629.webp 1756w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/19509b4e3471d1b8f741c688c0e4ccb9/e92b6/techletter.app-screenshot-1597679790629.png 223w", "/static/19509b4e3471d1b8f741c688c0e4ccb9/e66bf/techletter.app-screenshot-1597679790629.png 445w", "/static/19509b4e3471d1b8f741c688c0e4ccb9/4ef49/techletter.app-screenshot-1597679790629.png 890w", "/static/19509b4e3471d1b8f741c688c0e4ccb9/4e814/techletter.app-screenshot-1597679790629.png 1335w", "/static/19509b4e3471d1b8f741c688c0e4ccb9/49b61/techletter.app-screenshot-1597679790629.png 1756w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/19509b4e3471d1b8f741c688c0e4ccb9/4ef49/techletter.app-screenshot-1597679790629.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Not perfect, but better. Need to fix the child html nodes or find a JSX stringifier 🤔`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      